



















































import BaseComponent from '@/components/base-component.vue';
import RulesEngineConditionForm from '@/components/rules-engine/rule/condition-form.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: { RulesEngineConditionForm, PermissionAuth },
})
export default class RulesEngineRuleConditions extends BaseComponent {
  @Prop()
  public item: any;

  @Prop({default: false})
  public loading: boolean;

  public formOpen: boolean = false;
  public conditionFormIsEdit = false;
  public conditionFormItem: any = null;

  public headers: any = [
    { text: 'Entidade', value: 'entidade.descricao' },
    { text: 'Campo', value: 'campo', sortable: false },
    { text: 'Operador', value: 'operador', sortable: false },
    { text: 'Valor', value: 'valor', sortable: false },
    { text: 'Ações', value: 'name', sortable: false },
  ];

  public entities: any = [];
  public operators: any = [];

  public closeForm(): void {
    this.conditionFormIsEdit = false;
    this.conditionFormItem = null;
    this.formOpen = false;
  }

  public openForm(): void {
    this.formOpen = true;
  }

  public onNewConditionClick(): void {
    this.conditionFormIsEdit = false;
    this.conditionFormItem = {
      entidade: null,
      campo: null,
      operador: null,
      descricao: '',
      valor: '',
      isNew: true,
      crivo: null,
    };
    this.formOpen = true;
  }

  public onEditItem(item: any): void {
    this.conditionFormIsEdit = true;
    this.conditionFormItem = item;
    this.openForm();
  }

  public onCopyItem(item: any): void {
    this.conditionFormIsEdit = false;
    this.conditionFormItem = JSON.parse(JSON.stringify(item));
    this.openForm();
  }

  public onDeleteItem(item: any): void {
    const index = this.item.condicoes.findIndex((i) => i.id === item.id);
    this.item.condicoes.splice(index, 1);
  }

  public receiveFormData(condition: any): void {
    const uuidv4 = require('uuid/v4');
    if (!this.conditionFormIsEdit) {
      // New Item
      condition.id = uuidv4();
      this.item.condicoes.push(condition);
    } else {
      // Edit Item
      const index = this.item.condicoes.findIndex((i) => i.id === condition.id);
      this.$set(this.item.condicoes, index, condition);
    }

    this.closeForm();
  }
}
